define('datasource-manager/env',['require','exports','module'],function(require,exports,module){
	var STRING="string";
		return function(){
			var conf=module.config();
			return typeof conf===STRING && conf || "prod";
		}
});
